import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginForm from '../Components/LoginForm';
import Home from '../Components/Home';
import ForgotPassword from '../Components/ForgotPassword';




const RoutesConfig = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginForm/>} />
        <Route path="/:clientId/:email/:password" element={<Home />} />
        <Route path="/home" element={<Home/>}/>
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesConfig;
